import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { isAuthenticated, getCurrentUser } from '../../utils/auth';

const ProtectedRoute = ({ children }) => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [authenticated, setAuthenticated] = useState(false);

    useEffect(() => {
        checkAuth();
    }, []);

    const checkAuth = async () => {
        if (!isAuthenticated()) {
            navigate('/admin/login');
            return;
        }

        try {
            const user = await getCurrentUser();
            if (user) {
                setAuthenticated(true);
            } else {
                navigate('/admin/login');
            }
        } catch (error) {
            navigate('/admin/login');
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
            </div>
        );
    }

    if (!authenticated) {
        return null;
    }

    return children;
};

export default ProtectedRoute;

